function dateConvert(date) {
  const storeDate = new Date(date);
  return storeDate.toLocaleDateString();
}

export { dateConvert };
